import { render, staticRenderFns } from "./MedicalCertificate.vue?vue&type=template&id=77ccecba&scoped=true&"
import script from "./MedicalCertificate.vue?vue&type=script&lang=js&"
export * from "./MedicalCertificate.vue?vue&type=script&lang=js&"
import style0 from "./MedicalCertificate.vue?vue&type=style&index=0&id=77ccecba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ccecba",
  null
  
)

export default component.exports